import { useEffect, useState } from 'react'

import { useApiClient } from '@/shared/api/use-api-client'

import { companyApi, parseCompany } from './company'

/**
 * The names of these companies, each read once: a name is `undefined` while it loads, and `null`
 * for one the viewer may not see.
 */
export function useCompanyNames(ids: readonly string[]): ReadonlyMap<string, string | null> {
  const client = useApiClient()
  const key = ids.join(',')
  const [names, setNames] = useState<ReadonlyMap<string, string | null>>(() => new Map())

  useEffect(() => {
    if (key === '') {
      return undefined
    }
    const controller = new AbortController()
    for (const id of key.split(',')) {
      client
        .get(companyApi(id), controller.signal)
        .then((body) => setNames((now) => new Map(now).set(id, parseCompany(body).name)))
        .catch(() => {
          if (!controller.signal.aborted) {
            setNames((now) => new Map(now).set(id, null))
          }
        })
    }
    return () => controller.abort()
  }, [client, key])

  return names
}
